import { Checkbox, Section } from '@web_opxp/components';
import { LanguageSelectors, StatsSelectors, useTranslation } from '@web_opxp/features';
import { useDispatch, useSelector } from 'react-redux';
import { Action, Dispatch } from 'redux';
import { SKELETON_CLASSNAME } from '../base/constants';
import { CyclesSelectors } from '../cycles';
import './SpecialNeedsSection.scss';
import { PersonalizationActions } from './slice';
import { useColourblindnessStatValue, useDyscalculiaStatValue } from './specialNeedsHooks';

interface ISpecialNeedsSectionProps {
  userId?: number;
}

export default function SpecialNeedsSection({ userId }: Readonly<ISpecialNeedsSectionProps>) {
  const { t } = useTranslation();

  const langLoading = useSelector(LanguageSelectors.isLoading);
  const statsLoading = useSelector(StatsSelectors.isStatsLoading);
  const cyclesLoading = useSelector(CyclesSelectors.isCyclesLoading);
  const cyclesSaving = useSelector(CyclesSelectors.isCyclesSaving);
  const statsSaving = useSelector(StatsSelectors.isSaving);
  const workInProgress = cyclesSaving || statsSaving || cyclesLoading;
  const loading = langLoading || statsLoading || cyclesLoading;
  const skeletonClass = loading || workInProgress ? SKELETON_CLASSNAME : '';
  const dispatch = useDispatch<Dispatch<Action<string>>>();
  const colourblindness = useColourblindnessStatValue(userId);
  const colourblindnessHandler = (value: boolean) =>
    dispatch(PersonalizationActions.saveColourblindnessStat(value, userId));
  const dyscalculia = useDyscalculiaStatValue(userId);
  const dyscalculiaHandler = (value: boolean) => dispatch(PersonalizationActions.saveDyscalculiaStat(value, userId));
  return (
    <Section className="special-needs-section">
      <div className="row">
        <div className="title col-4">
          <h3 className={skeletonClass}>{t('Personalization.SpecialNeeds.Title')}</h3>
        </div>
        <div className="content col-8">
          <p className={skeletonClass}>{t('Personalization.SpecialNeeds.Description')}</p>
        </div>
      </div>
      <div className="row">
        <div className="col-4" />
        <div className="col-8">
          <div className="row">
            {!loading && (
              <Checkbox
                className="checkboxContainer col-6"
                id="sn-colourblindness"
                checked={colourblindness}
                disabled={workInProgress}
                onChange={colourblindnessHandler}>
                <span>{t(`Personalization.SpecialNeeds.ColourBlindness`)}</span>
              </Checkbox>
            )}
          </div>
          <div className="row">
            {!loading && (
              <Checkbox
                className="checkboxContainer col-6"
                id="sn-dyscalculia"
                checked={dyscalculia}
                disabled={workInProgress}
                onChange={dyscalculiaHandler}>
                <span>{t(`Personalization.SpecialNeeds.Dyscalculia`)}</span>
              </Checkbox>
            )}
          </div>
        </div>
      </div>
    </Section>
  );
}
